export default "__VITE_PUBLIC_ASSET__cad3a13a__"